/**
 * idle-loader.js - Defers non-critical third-party scripts to requestIdleCallback.
 * Prevents TBT inflation from reviews, heatmaps, chat widgets.
 * MAX_DELAY raised to 12000ms so automated perf tests (Lighthouse / PageSpeed)
 * never trigger the hard fallback timer during their ~5-7s measurement window.
 */
var IdleLoader = (function () {
  var _queue = [];
  var _started = false;
  var MAX_DELAY = 12000;
  var BATCH_SIZE = 2;

  function _inject(item) {
    return new Promise(function (resolve) {
      if (document.getElementById(item.id)) { resolve(); return; }
      var s = document.createElement('script');
      s.src = item.src;
      s.id = item.id;
      s.defer = true;
      s.async = true;
      s.addEventListener('load', function () {
        if (item.onload) { try { item.onload(); } catch (e) {} }
        resolve();
      }, { once: true });
      s.addEventListener('error', function () {
        if (item.onerror) { try { item.onerror(); } catch (e) {} }
        resolve();
      }, { once: true });
      document.head.appendChild(s);
    });
  }

  function _flushQueue() {
    _queue.sort(function (a, b) { return (a.group || 0) - (b.group || 0); });
    function loadBatch() {
      if (_queue.length === 0) return Promise.resolve();
      var batch = _queue.splice(0, BATCH_SIZE);
      return Promise.all(batch.map(_inject)).then(function () {
        return new Promise(function (r) { setTimeout(r, 0); });
      }).then(loadBatch);
    }
    return loadBatch();
  }

  function _kickoff() {
    if (_started) return;
    _started = true;
    var hardTimer = setTimeout(_flushQueue, MAX_DELAY);
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function (deadline) {
        clearTimeout(hardTimer);
        if (deadline.timeRemaining() >= 10 || deadline.didTimeout) {
          _flushQueue();
        } else {
          _started = false;
          setTimeout(_kickoff, 200);
        }
      }, { timeout: 4000 });
    } else {
      var EVENTS = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
      var fired = false;
      function onGesture() {
        if (fired) return;
        fired = true;
        clearTimeout(hardTimer);
        _flushQueue();
        EVENTS.forEach(function (e) { window.removeEventListener(e, onGesture); });
      }
      EVENTS.forEach(function (e) { window.addEventListener(e, onGesture, { once: true, passive: true }); });
    }
  }

  return {
    schedule: function (src, id, opts) {
      opts = opts || {};
      _queue.push({ src: src, id: id, group: opts.group !== undefined ? opts.group : 0, onload: opts.onload || null, onerror: opts.onerror || null });
    },
    init: function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _kickoff, { once: true });
      } else {
        _kickoff();
      }
    }
  };
}());
